<div class="top-navi-container">
  <button class="top-navi" (click)="onNavigateBack()" mat-button><mat-icon>arrow_back</mat-icon>Zurück</button>
  <!-- <button
    class="top-navi align-right"
    #tooltip="matTooltip"
    (click)="tooltip.toggle()"
    [matTooltip]="anleitung"
    matTooltipPosition="before"
    mat-button>
    <mat-icon>info</mat-icon>Anleitung
  </button> -->
</div>

<mat-card class="card">
  <mat-card-content>
    @if (assessmentData(); as assessmentData) {
      @if (assessmentData) {
        <div class="grid">
          <app-single-number-table-input
            (inputData)="onData($event)"
            [startTabIndex]="1"
            [note]="assessmentData.mwt6.note"
            [title]="assessmentData.mwt6.title"
            [data]="assessmentData.mwt6.data">
          </app-single-number-table-input>
        </div>
      }
    }
    <form class="input-form" [formGroup]="form">
      <mat-form-field class="input" id="dateErhebung">
        <mat-label>Zeitpunkt der Testung</mat-label>
        <input type="datetime-local" matInput formControlName="assessmentTime" placeholder="" />
      </mat-form-field>
    </form>
    <div class="buttons">
      @if (assessmentId) {
        <button mat-raised-button color="secondary" (click)="onDelete(assessmentId)">Testung löschen</button>
      }
      <button mat-raised-button color="primary" (click)="onSave()">Testung speichern</button>
    </div>
  </mat-card-content>
</mat-card>
